import React, { useEffect } from "react";
import PopupFooter from ".";
import bgHeader from "../../../../../assets/images/Mini-Game/header-mission.png";
import { useTranslation } from "react-i18next";
import { Divider } from "antd";
import moment from "moment-timezone";
import { getData } from "../../../../../utils/localstorage";
import { HIDDEN_POPUP_RANKING_MINIGAME } from "../../../../../helper/const";
import { useDispatch, useSelector } from "react-redux";
import { curStateMiniGame } from "../../../../../Redux/selector";
import {
  getConfigMiniGame,
  getDataAwardListMiniGame,
  getRuleMiniGame,
} from "../../../../../Redux/futures/mini-game/action";
import _ from "lodash";

function checkMonthT9() {
  if (getData("isMonth9")) {
    return true;
  }

  const now = moment(); // thời gian hiện tại
  const target = moment("2025-09-01 00:00:00", "YYYY-MM-DD HH:mm:ss");

  return now.isAfter(target); // true nếu >, false nếu <=
}

export default function PopupRule({ isShowPopupIntro, setIsShowPopupIntro }) {
  const { t } = useTranslation();
  const {
    dataRule = [],
    configMiniGame = {},
    dataAwardListMini = [],
  } = useSelector(curStateMiniGame);
  const dispatch = useDispatch();

  useEffect(() => {
    if (!dataRule || _.isEmpty(dataRule)) {
      dispatch(getRuleMiniGame());
    }

    if (!configMiniGame || _.isEmpty(configMiniGame)) {
      dispatch(getConfigMiniGame());
    }

    if (!dataAwardListMini || _.isEmpty(dataAwardListMini)) {
      dispatch(getDataAwardListMiniGame());
    }
  }, []);

  const renderPrizes = [
    {
      id: 1,
      title: t("mini_game.pop_up_rule.current.title_super"),
      content: t("mini_game.pop_up_rule.current.super_prizes", {
        returnObjects: true,
      }),
    },
    {
      id: 2,
      title: t("mini_game.pop_up_rule.current.title_normal"),
      content: t("mini_game.pop_up_rule.current.normal_prizes", {
        returnObjects: true,
      }),
    },
  ];
  const renderMisc = [
    {
      id: 1,
      title: t("mini_game.pop_up_rule.exchange_turns.title"),
      content: t("mini_game.pop_up_rule.exchange_turns.content", {
        returnObjects: true,
      }),
    },
    {
      id: 2,
      title: t("mini_game.pop_up_rule.super_coin.title"),
      content: t("mini_game.pop_up_rule.super_coin.content", {
        returnObjects: true,
      }),
    },
    {
      id: 3,
      title: t("mini_game.pop_up_rule.rules.title"),
      content: t("mini_game.pop_up_rule.rules.content", {
        returnObjects: true,
      }),
    },
    {
      id: 4,
      title: t("mini_game.pop_up_rule.how_to_know.title"),
      content: t("mini_game.pop_up_rule.how_to_know.content", {
        returnObjects: true,
      }),
    },
    {
      id: 5,
      title: t("mini_game.pop_up_rule.how_prizes_given.title"),
      content: t("mini_game.pop_up_rule.how_prizes_given.content", {
        returnObjects: true,
      }),
    },
    {
      id: 6,
      title: t("mini_game.pop_up_rule.note.title"),
      content: t("mini_game.pop_up_rule.note.content", {
        returnObjects: true,
      }),
    },
  ];

  const renderRanking = t("mini_game.pop_up_rule.invite_leaderboard_rules", {
    returnObjects: true,
  });

  const dataArrayRanking = Object.entries(renderRanking).map(
    ([section, value]) => ({
      section,
      ...value,
    }),
  );

  const variables = {
    START_TIME: "[START_TIME]",
    END_TIME: "[END_TIME]",
    SUPER_PRIZE: "[SUPER_PRIZE]",
    NORMAL_PRIZE: "[NORMAL_PRIZE]",
  };

  const variableKeys = {
    "[START_TIME]": configMiniGame?.minigame?.start_time
      ? moment
          .tz(configMiniGame?.minigame?.start_time, "Asia/Yangon")
          .tz(moment.tz.guess())
          .format("DD/MM/YYYY (HH:mm:ss)")
      : "",
    "[END_TIME]": configMiniGame?.minigame?.end_time
      ? moment
          .tz(configMiniGame?.minigame?.end_time, "Asia/Yangon")
          .tz(moment.tz.guess())
          .format("DD/MM/YYYY (HH:mm:ss)")
      : "",
    "[SUPER_PRIZE]": dataAwardListMini
      .filter((item) => item.is_super_prize == 1)
      .map((item) => {
        if (item.price && item.price > 0 && item.full_name) {
          return `<li>${item.full_name} - ${new Intl.NumberFormat(
            "en-US",
          ).format(item.price)} MMK (${item.total_num})</li>`;
        }
        if (!item.price) {
          return `<li>${item.full_name}</li>`;
        }
        return "";
      })
      .join(""),
    "[NORMAL_PRIZE]": dataAwardListMini
      .filter((item) => item.is_super_prize != 1)
      .map((item) => {
        if (item.price && item.price > 0 && item.full_name) {
          return `<li>${item.full_name} - ${new Intl.NumberFormat(
            "en-US",
          ).format(item.price)} MMK (${item.total_num})</li>`;
        }

        if (!item.price) {
          return `<li>${item.full_name}</li>`;
        }

        return "";
      })
      .join(""),
  };

  const replaceAllPlaceholders = (content, placeholder, value) =>
    content.split(placeholder).join(value);

  return (
    <div className="popup-minigame__2025">
      <PopupFooter
        isOpen={isShowPopupIntro}
        onClose={() => setIsShowPopupIntro(false)}
        className={"popup-rule-mini rule-scroll"}
      >
        <>
          <div className="header-mini-popup-rule">
            <img src={bgHeader} alt="" className="img-rule-mini" />
            <div className="content-rule-mini">
              {t("mini_game.pop_up_rule.name")}
            </div>
          </div>
          <div className="box-content-minigame-popup__container box-content-minigame-popup__scroll">
            {dataRule &&
              dataRule.length > 0 &&
              dataRule.map((item, index) => (
                <div className="box-content-minigame-popup">
                  {item.title && (
                    <div className="title-popup-mini">{item.title}</div>
                  )}
                  <div
                    className="popup-mini-content"
                    dangerouslySetInnerHTML={{
                      __html: replaceAllPlaceholders(
                        replaceAllPlaceholders(
                          replaceAllPlaceholders(
                            replaceAllPlaceholders(
                              item.content,
                              variables.START_TIME,
                              variableKeys[variables.START_TIME],
                            ),
                            variables.END_TIME,
                            variableKeys[variables.END_TIME],
                          ),
                          variables.SUPER_PRIZE,
                          `<ul>${variableKeys[variables.SUPER_PRIZE]}</ul>`,
                        ),
                        variables.NORMAL_PRIZE,
                        `<ul>${variableKeys[variables.NORMAL_PRIZE]}</ul>`,
                      ),
                    }}
                  />
                </div>
              ))}
          </div>
        </>
      </PopupFooter>
    </div>
  );
}
